import {withFormsy} from 'formsy-react';
import React, {useState} from 'react';
import PropTypes from 'prop-types';


let Checkbox = (props) => {
    const [formId] = useState(TB.guid())

    return (
        <div className={TB.mapClass("form-group", {
            [props.checkboxClass]: props.checkboxClass
        })}>
            <div className={TB.mapClass("form-checkbox", {
                "disabled-checkbox":props.disabled
            })}>

                <input type="checkbox"
                       className="form-check-input"
                       name={props.name}
                       id={"checkbox" + formId}
                       required={props.required}
                       disabled={props.disabled}
                       onChange={event => props.setValue(event.currentTarget.checked)}
                       checked={props.value === true}/>

                <label className="form-check-label" htmlFor={"checkbox" + formId}>
                    {props.valueLabel}
                </label>


            </div>
            {props.errorMessage && (
                <span className={'invalid-feedback'}>
                    {props.errorMessage}
                </span>
            )}
        </div>
    )
};

const CheckboxInput = withFormsy(Checkbox);

CheckboxInput.propTypes = {
    checkboxClass: PropTypes.string,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    required: PropTypes.bool,
    setValue: PropTypes.func,
    valueLabel: PropTypes.any,
    errorMessage: PropTypes.string,
};

export default CheckboxInput;


// this checkbox is meant to be used OUTSIDE of formsy
export const CheckBox = (props) => {
    const [formId] = useState(TB.guid());

    return (
        <div className={TB.mapClass("form-checkbox", {
            "disabled-checkbox": props.disabled,
            [props.checkboxClass]: props.checkboxClass
        })}>
            <input
                type="checkbox"
                className="form-check-input"
                name={props.name}
                id={"checkbox" + formId}
                required={props.required}
                disabled={props.disabled}
                onChange={event => props.setValue(event.currentTarget)}
                checked={props.value === true}
            />

            <label className={`form-check-label ${props.labelClassName || ''}`} htmlFor={"checkbox" + formId}>
				{props.label}
			</label>
        </div>
    )
}


CheckBox.propTypes = {
    checkboxClass: PropTypes.string,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    label: PropTypes.any,
    required: PropTypes.bool,
    setValue: PropTypes.func,
    labelClassName: PropTypes.string,
};
